import { render, staticRenderFns } from "./TicketProductDetail.vue?vue&type=template&id=4de6eca3&scoped=true&"
import script from "./TicketProductDetail.vue?vue&type=script&lang=js&"
export * from "./TicketProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de6eca3",
  null
  
)

export default component.exports